import { getFragmentData, type FragmentType } from '@packages/gql/generated/shopping';
import { BrandRecommendationFragmentFragmentDoc } from '@packages/gql/generated/shopping/BrandRecommendationFragmentFragmentDoc';
import { GlycerinTileType } from '@packages/tracking/src/types/enums';
import type { GlycerinTile } from '@packages/tracking/src/types/types';

/**
 * This function is used to retrieve the Glycerin tiles from the recommendations.
 *
 * @param recommendations - The recommendations to map to Glycerin tiles.
 * @returns GlycerinTile[] - An array of GlycerinTile objects.
 */
export const getBrandGlycerinTiles = (
  recommendationsData: Array<FragmentType<typeof BrandRecommendationFragmentFragmentDoc>>,
): GlycerinTile[] => {
  const recommendations = getFragmentData(
    BrandRecommendationFragmentFragmentDoc,
    recommendationsData,
  );

  return recommendations.map((recommendation, index) => {
    const tileType: GlycerinTileType = GlycerinTileType.CATEGORY;

    return {
      tileType,
      listPosition: index + 1,
      categoryId: recommendation.brand.categoryId,
    };
  });
};
